"use client";

import SomethingWentWrong from "@/components/ui/something-went-wrong";
import { useEffect } from "react";

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
	useEffect(() => {
		console.error(error);
	}, [error]);

	return (
		<>
			<SomethingWentWrong error={error}>
				<button
					onClick={() => reset()}
					className="mx-auto mt-6 block rounded-md bg-brand-primary px-6 py-4 text-xl font-medium text-white"
				>
					Refresh
				</button>
			</SomethingWentWrong>
		</>
	);
}
